(() => {
  if (window.ultiCatalogInitialized) return;
  window.ultiCatalogInitialized = true;
  const element = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text != null) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  function descriptionText(source) {
    const clone = source.cloneNode(true);
    clone.querySelectorAll('script,style').forEach(node => node.remove());
    clone.querySelectorAll('p,li,div,h1,h2,h3,h4,h5,h6,br').forEach(node => node.append('\n'));
    return clone.textContent.replace(/\u00a0/g, ' ').replace(/[ \t]+/g, ' ').replace(/\n{2,}/g, '\n').split('\n').map(line => line.trim()).filter(Boolean);
  }
  function extractFeatures(text) {
    const parts = text.split(/(?:^|(?<=[.)]\s))([A-Z][A-Za-z0-9 '\u2019/\-]{2,40}\s?:\s)/g).filter(part => part.trim());
    if (parts.length < 4 || parts.length % 2) return [];
    const features = [];
    for (let i = 0; i < parts.length; i += 2) features.push({ label: parts[i].replace(/\s*:\s*$/, '').trim(), body: parts[i + 1].trim() });
    return features;
  }
  function enhance(root) {
    if (root.dataset.catalogReady) return;
    root.dataset.catalogReady = 'true';
    root.querySelectorAll('[data-catalog-option-label]').forEach(label => {
      const known = { color: 'Color', colour: 'Color', colorfamily: 'Color', colourfamily: 'Color', framecolor: 'Frame Color', framecolour: 'Frame Color', desksize: 'Desk Size', topmaterial: 'Desktop Material' };
      const raw = label.textContent;
      label.textContent = known[raw.replace(/[^a-z0-9]/gi, '').toLowerCase()] || raw.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/[_-]+/g, ' ').trim().split(/\s+/).map(word => /^(rgb|usb|vesa|tv|pc)$/i.test(word) ? word.toUpperCase() : word[0].toUpperCase() + word.slice(1).toLowerCase()).join(' ');
    });
    const description = root.querySelector('[data-catalog-description]');
    if (!description) return;
    const paragraphs = descriptionText(description);
    const features = extractFeatures(paragraphs.join(' '));
    const output = document.createDocumentFragment();
    if (features.length) {
      const list = element('dl', null, 'ulti-catalog-features');
      features.forEach(feature => {
        const row = element('div');
        row.append(element('dt', feature.label), element('dd', feature.body));
        list.append(row);
      });
      output.append(list);
    } else {
      const isLabel = line => /:$/.test(line) && line.length <= 60;
      for (let i = 0; i < paragraphs.length; i++) {
        const line = paragraphs[i];
        if (isLabel(line) && i + 1 < paragraphs.length && !isLabel(paragraphs[i + 1])) {
          const note = /note/i.test(line);
          const group = element('div', null, note ? 'ulti-catalog-note' : 'ulti-catalog-checklist');
          group.append(element('h3', line.replace(/:$/, '')));
          const list = element(note ? 'div' : 'ul');
          while (i + 1 < paragraphs.length && !isLabel(paragraphs[i + 1])) list.append(element(note ? 'p' : 'li', paragraphs[++i]));
          group.append(list);
          output.append(group);
        } else output.append(element('p', line));
      }
    }
    // Keep rich product media, links and tables intact; textual descriptions use the source grouping rules.
    if (!description.querySelector('img,video,iframe,table,a') && paragraphs.length) description.replaceChildren(output);
    const imageData = root.querySelector('[data-catalog-images]');
    const target = root.querySelector('[data-catalog-highlights]');
    if (!imageData || !target || !features.length) return;
    let images;
    try { images = JSON.parse(imageData.textContent); } catch { return; }
    images.forEach((image, index) => {
      const feature = features[index];
      if (!feature || /^notes?$/i.test(feature.label) || /got you covered/i.test(feature.label) || /trademark/i.test(feature.body)) return;
      const article = element('article', null, 'ulti-catalog-highlight');
      const frame = element('div', null, 'ulti-catalog-highlight-image');
      const img = element('img');
      img.src = image.url;
      img.alt = image.alt || feature.label;
      img.width = image.width;
      img.height = image.height;
      img.loading = 'lazy';
      frame.append(img);
      const copy = element('div');
      copy.append(element('h2', feature.label), element('p', feature.body));
      article.append(frame, copy);
      target.append(article);
    });
    if (target.childElementCount) root.querySelector('[data-catalog-derived]').hidden = false;
  }
  const initialize = () => document.querySelectorAll('[data-ulti-catalog]').forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
